<template>
  <button class="map-btn" :class="classBtn" v-on="$listeners" v-bind="$attrs" :disabled="disabled">
    <i v-if="icon" class="map-icon" :class="icon"></i>
    <!-- slot -->
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    btnClass: {
      type: String,
      default: "btnPrimary"
    },
    size: {
      type: String,
      default: "medium"
    },
    type: {
      type: String,
      default: "primary"
    },
    fullwidth: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      btnSize: ["tiny", "mini", "small", "medium", "large", "big"],
      btnType: [
        "blue",
        "black",
        "green",
        "red",
        "white",
        "grey",
        "text",
        "border"
      ]
    };
  },
  computed: {
    classBtn() {
      const prefix = " map-btn--";
      const type =
        this.btnType.indexOf(this.type) == -1
          ? prefix + "blue"
          : prefix + this.type;
      const fw = !this.fullwidth ? "" : prefix + "fullwidth";
      const size =
        this.size == "medium" || this.btnSize.indexOf(this.size) == -1
          ? ""
          : prefix + this.size;
      return (type + size + fw).trim();
    }
  }
};
</script>
